import React from 'react';
import { CheckIcon } from 'lucide-react';
const AboutUs = () => {
  return <div className="w-full" data-id="element-144">
      {/* Header Section */}
      <section className="relative py-20 bg-[#E57C23]" data-id="element-145">
        <div className="container mx-auto px-4" data-id="element-146">
          <div className="text-center" data-id="element-147">
            <h1 className="text-4xl font-bold text-white mb-4" data-id="element-148">About Us</h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-149">
              Learn more about Realmpoint and our commitment to excellence
            </p>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-150">
        <div className="container mx-auto px-4" data-id="element-151">
          <div data-id="element-152">
            <h2 className="text-3xl font-bold text-[#E57C23] mb-6" data-id="element-153">
              Our Story
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-154">
              At Realmpoint, we specialise in fast, professional appliance
              repairs and service plans across the UK. From kitchens to living
              rooms, our trusted engineers are here to help with any appliance
              issue you might face.
            </p>
            <p className="text-lg text-gray-600 mb-6" data-id="element-155">
              We understand how disruptive a malfunctioning appliance can be to
              your daily routine. That's why we've built our service around
              reliability, expertise, and customer satisfaction. Our team of
              highly trained engineers brings years of experience to every job,
              ensuring your appliances are repaired efficiently and effectively.
            </p>
            <p className="text-lg text-gray-600" data-id="element-156">
              We offer fixed-price support, UK-based service, and peace of mind
              for every home. With Realmpoint, you're not just getting a repair
              service – you're gaining a trusted partner for all your appliance
              needs.
            </p>
          </div>
          {/* Why Choose Us */}
          <div className="mt-20" data-id="element-157">
            <div className="text-center mb-12" data-id="element-158">
              <h2 className="text-3xl font-bold text-[#E57C23]" data-id="element-159">
                Why Choose Realmpoint
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-160">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-161">
                <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-4" data-id="element-162">
                  <CheckIcon className="w-6 h-6 text-[#F8B179]" data-id="element-163" />
                </div>
                <h3 className="text-xl font-bold text-[#E57C23] mb-3" data-id="element-164">
                  Expert Engineers
                </h3>
                <p className="text-gray-600" data-id="element-165">
                  Our engineers are fully qualified, experienced, and trained to
                  work on a wide range of appliances. They undergo regular
                  training to stay updated with the latest technologies.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-166">
                <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-4" data-id="element-167">
                  <CheckIcon className="w-6 h-6 text-[#F8B179]" data-id="element-168" />
                </div>
                <h3 className="text-xl font-bold text-[#E57C23] mb-3" data-id="element-169">
                  Transparent Pricing
                </h3>
                <p className="text-gray-600" data-id="element-170">
                  We believe in complete transparency. Our fixed-price plans
                  mean no surprise costs or hidden fees. You'll always know
                  exactly what you're paying for.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-171">
                <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-4" data-id="element-172">
                  <CheckIcon className="w-6 h-6 text-[#F8B179]" data-id="element-173" />
                </div>
                <h3 className="text-xl font-bold text-[#E57C23] mb-3" data-id="element-174">
                  Fast Response
                </h3>
                <p className="text-gray-600" data-id="element-175">
                  We understand that a faulty appliance needs immediate
                  attention. That's why we aim to respond quickly to all service
                  requests, with most repairs scheduled within 24-48 hours.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-176">
                <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-4" data-id="element-177">
                  <CheckIcon className="w-6 h-6 text-[#F8B179]" data-id="element-178" />
                </div>
                <h3 className="text-xl font-bold text-[#E57C23] mb-3" data-id="element-179">
                  Nationwide Coverage
                </h3>
                <p className="text-gray-600" data-id="element-180">
                  Our services extend across the UK, ensuring that no matter
                  where you are, reliable appliance repair is just a phone call
                  away.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-181">
                <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-4" data-id="element-182">
                  <CheckIcon className="w-6 h-6 text-[#F8B179]" data-id="element-183" />
                </div>
                <h3 className="text-xl font-bold text-[#E57C23] mb-3" data-id="element-184">
                  Customer Satisfaction
                </h3>
                <p className="text-gray-600" data-id="element-185">
                  Your satisfaction is our priority. We're committed to
                  providing exceptional service and won't rest until your
                  appliance is working perfectly.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-186">
                <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-4" data-id="element-187">
                  <CheckIcon className="w-6 h-6 text-[#F8B179]" data-id="element-188" />
                </div>
                <h3 className="text-xl font-bold text-[#E57C23] mb-3" data-id="element-189">
                  Peace of Mind
                </h3>
                <p className="text-gray-600" data-id="element-190">
                  Our service plans offer complete peace of mind, knowing that
                  your essential appliances are protected against breakdowns and
                  faults.
                </p>
              </div>
            </div>
          </div>
          {/* Our Values */}
          <div className="mt-20" data-id="element-191">
            <div className="text-center mb-12" data-id="element-192">
              <h2 className="text-3xl font-bold text-[#E57C23]" data-id="element-193">Our Values</h2>
            </div>
            <div className="bg-[#FFF8F0] p-8 rounded-lg" data-id="element-194">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-195">
                <div data-id="element-196">
                  <h3 className="text-xl font-bold text-[#E57C23] mb-4" data-id="element-197">
                    Reliability
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-198">
                    We understand the importance of keeping your promises. When
                    we say we'll be there, we will be. Our service is built on
                    reliability and dependability.
                  </p>
                  <h3 className="text-xl font-bold text-[#E57C23] mb-4" data-id="element-199">
                    Excellence
                  </h3>
                  <p className="text-gray-600" data-id="element-200">
                    We strive for excellence in everything we do, from customer
                    service to technical repairs. Our team is dedicated to
                    delivering the highest standards of workmanship.
                  </p>
                </div>
                <div data-id="element-201">
                  <h3 className="text-xl font-bold text-[#E57C23] mb-4" data-id="element-202">
                    Integrity
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-203">
                    Honesty and transparency are at the heart of our business.
                    We provide clear information, fair pricing, and honest
                    advice about your appliance repairs.
                  </p>
                  <h3 className="text-xl font-bold text-[#E57C23] mb-4" data-id="element-204">
                    Customer Focus
                  </h3>
                  <p className="text-gray-600" data-id="element-205">
                    Everything we do is centered around you, our customer. We
                    listen to your needs and work tirelessly to exceed your
                    expectations with every interaction.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default AboutUs;